import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import MerchantJoin from './MerchantJoin'
import '@common/styles/global.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#fb693e',
        },
      }}
    >
      <MerchantJoin />
    </ConfigProvider>
  </React.StrictMode>
)

